import { Injectable, inject } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs';
import { FrontendLoggerService } from '@surface-elements/shared/util-logging';

@Injectable()
export class HttpErrorLoggingInterceptor implements HttpInterceptor {
  private readonly logger = inject(FrontendLoggerService);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const errorDetails = {
          url: req.url,
          method: req.method,
          status: error.status,
          statusText: error.statusText,
          message: error.message,
          error: error.error,
        };

        if (error.status >= 500) {
          this.logger.error(
            `HTTP ${error.status}: ${req.method} ${req.url}`,
            errorDetails,
            'HttpErrorLoggingInterceptor',
          );
        } else if (error.status >= 400) {
          this.logger.warn(
            `HTTP ${error.status}: ${req.method} ${req.url}`,
            errorDetails,
            'HttpErrorLoggingInterceptor',
          );
        } else {
          this.logger.error(
            `HTTP Error: ${req.method} ${req.url}`,
            errorDetails,
            'HttpErrorLoggingInterceptor',
          );
        }

        return throwError(() => error);
      }),
    );
  }
}
